export default (that) => [
  {
    exportName: that.$l('INDEX.btn_export_shippingadvice') || '导出发运通知书',
    templateGroup: 'shipment-shippingadvice',
    exportCheckUrl: '/factory/shipmentInfo/shipment/checkData',
  },
]
